import { dataLayerUserData } from "@/utils/dataLayerUserData";
import { hasLoggedInMarker, identityQuery } from "@/utils/identity";
import { queryClient } from "@/utils/queryClient";
import { trackCreatedAccount } from "@/utils/trackCreatedAccount";

let previousPageUrl: string | null = null;

/*
 * GTM records the first page view itself, so only navigations inside the SPA
 * are pushed.
 */
export function trackSpaPageView() {
    const pageUrl = window.location.href;
    if (previousPageUrl !== null && previousPageUrl !== pageUrl) {
        dataLayer.push({
            event: "page_view",
            page_location: pageUrl,
            prev_page_location: previousPageUrl,
        });
    }
    previousPageUrl = pageUrl;
}

/*
 * logged_in_state goes out once per page load, and created_account whenever
 * an identity answer reports a fresh registration (the server only reports it
 * once).
 */
export function trackIdentityEvents() {
    let hasReportedLoggedInState = false;

    if (!hasLoggedInMarker()) {
        dataLayer.push({ event: "logged_in_state" });
        hasReportedLoggedInState = true;
    }

    queryClient.getQueryCache().subscribe((event) => {
        if (
            event.type !== "updated" ||
            event.action.type !== "success" ||
            event.query.queryKey[0] !== identityQuery.queryKey[0]
        ) {
            return;
        }

        const identity = queryClient.getQueryData(identityQuery.queryKey);
        if (!identity) {
            return;
        }

        if (!hasReportedLoggedInState) {
            dataLayer.push({
                event: "logged_in_state",
                ...(identity.user ? dataLayerUserData(identity.user) : {}),
            });
            hasReportedLoggedInState = true;
        }

        trackCreatedAccount(identity);
    });
}
